import queryString from 'query-string'
import apiClient from './api-client'

function getPractices(page, q, showInactive) {
  const pageQuery = page === 'all' ? { all: true } : { page }
  return apiClient.get(
    queryString.stringifyUrl({
      url: 'practices',
      query: {
        ...pageQuery,
        // avoid sending when false (string false is also truthy)
        show_inactive: showInactive || undefined,
        q,
      },
    }),
    { withHeaders: true },
  )
}

function createPractice(practice) {
  return apiClient.post('practices', practice)
}

function updatePractice(id, practiceData) {
  return apiClient.patch(`practices/${id}`, practiceData)
}

function getPractice(id) {
  return apiClient.get(`practices/${id}`)
}

function deletePractice(id) {
  return apiClient.destroy(`practices/${id}`)
}

async function checkIntegrationName(integrationName) {
  const practices = await apiClient.get(
    queryString.stringifyUrl({
      url: 'practices',
      query: { integration_name: integrationName },
    }),
  )
  if (practices.length === 0) return { available: true }
  return {
    available: false,
    message: `This integration name is already taken by ${practices[0].name}`,
  }
}

function getCycles(id) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `practices/${id}/cycles`,
      query: { all: true },
    }),
  )
}

function getProviders(id, headers = false) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `practices/${id}/providers`,
      query: { all: true },
    }),

    { withHeaders: headers },
  )
}

function getMedicalProviders(id, headers = false) {
  return apiClient.get(
    queryString.stringifyUrl({
      url: `practices/${id}/medical-providers`,
      query: { all: true },
    }),

    { withHeaders: headers },
  )
}

function setProvider(id, userId) {
  return apiClient.post(`practices/${id}/providers`, { userId })
}

function unsetProvider(id, userId) {
  return apiClient.destroy(`practices/${id}/providers/${userId}`)
}

function getPracticeOfficeLocations(practiceId, options = {}) {
  const { paginated, page, perPage } = options
  const getPath = paginated
    ? queryString.stringifyUrl({
        url: `practices/${practiceId}/office-locations`,
        query: { page, per_page: perPage },
      })
    : `practices/${practiceId}/office-locations`
  return apiClient.get(getPath, { withHeaders: paginated })
}

function addPracticeOfficeLocation(practiceId, data) {
  return apiClient.post(`/practices/${practiceId}/office-locations`, data)
}

function deletePracticeOfficeLocation(practiceId, id) {
  return apiClient.destroy(`/practices/${practiceId}/office-locations/${id}`)
}

function updatePracticeOfficeLocation(practiceId, id, data) {
  return apiClient.patch(
    `/practices/${practiceId}/office-locations/${id}`,
    data,
  )
}

const Practices = {
  deletePractice,
  getCycles,
  getPractices,
  getPractice,
  createPractice,
  updatePractice,
  checkIntegrationName,
  getProviders,
  setProvider,
  unsetProvider,
  getMedicalProviders,
  getPracticeOfficeLocations,
  addPracticeOfficeLocation,
  updatePracticeOfficeLocation,
  deletePracticeOfficeLocation,
}

export default Practices
